import { Button, LuIcon, Text } from "@overmap-ai/blocks"
import { selectProjectById } from "@overmap-ai/core"
import { getRouteApi, Link } from "@tanstack/react-router"
import { memo } from "react"

import { modelIconMapping } from "../../mappings/icons"
import { useAppSelector } from "../../store"
import { BaseTopBar } from "../TopBars/BaseTopBar"

const routeApi = getRouteApi("/_loggedIn/$organizationId/_map/_layout/settings/projects/$projectId/attachments")

export const ProjectSettingsAttachmentsViewTopBar = memo(() => {
	const { projectId } = routeApi.useParams()
	const project = useAppSelector(selectProjectById(projectId))!

	return (
		<BaseTopBar
			showAIButton={false}
			leftContent={
				<Link
					from="/$organizationId/settings/projects/$projectId/attachments"
					to="/$organizationId/settings/projects/$projectId"
				>
					<Button>
						<LuIcon icon={modelIconMapping.arrowLeft} />
						<LuIcon icon={modelIconMapping.project} />
						<Text>{project.name}</Text>
					</Button>
				</Link>
			}
		/>
	)
})
ProjectSettingsAttachmentsViewTopBar.displayName = "ProjectSettingsAttachmentsViewTopBar"
